import {
  Button,
  ButtonGroup,
  Flex,
  Image,
  Input,
  Text,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import Modal from "react-modal";
import {
  deleteYoutubeVideoData,
  editYoutubeVideoData,
} from "../../../services/VideoAPI";

const VideoCard = (props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [value, setValue] = useState(props.title); // 동영상제목
  const handleChange = (event) => setValue(event.target.value);

  const [videoUrl, setVideoUrl] = useState(props.url); // 제목
  const handleVideoChange = (event) => setVideoUrl(event.target.value);

  const [imageInformation, setImageInformation] = useState();

  useEffect(() => {
    let lastUrl = videoUrl.split("/");
    let urlLocation = lastUrl[lastUrl.length - 1];
    let handledLocation = urlLocation.split("=");
    setImageInformation(handledLocation[handledLocation.length - 1]);
  }, [videoUrl]);

  const deleteData = () => {
    deleteYoutubeVideoData(props.id).then((response) => {
      alert("동영상이 삭제되었습니다.");
      setIsModalOpen(false);
      props.setUpdateState(Math.random());
    });
  };

  const editData = () => {
    editYoutubeVideoData(props.id, value, videoUrl).then(() => {
      alert("동영상 정보가 수정되었습니다!");
      setIsModalOpen(false);
      props.setUpdateState(Math.random());
    });
  };

  const clearState = () => {
    setValue(props.title);
    setVideoUrl(props.url);
    setIsModalOpen(false);
  };

  const confirmForm = () => {
    if (value === "" && videoUrl === "") {
      alert("제목과 동영상 주소를 입력해주세요!");
    } else if (value === "") {
      alert("제목을 입력해주세요!");
    } else if (videoUrl === "") {
      alert("동영상 주소를 입력해주세요!");
    } else {
      questionBeforeEdit();
    }
  };

  const questionBeforeEdit = () => {
    if (window.confirm("수정하시겠습니까?")) {
      editData();
    } else {
      alert("동영상 정보 수정을 취소합니다.");
    }
  };

  const questionBeforeDelete = () => {
    if (window.confirm("정말 삭제하시겠습니까?")) {
      deleteData();
    } else {
      alert("동영상 삭제를 취소합니다.");
    }
  };

  return (
    <>
      <div
        className="w-[400px] h-[270px] flex flex-col mb-[20px] mr-[5px] justify-center items-center text-[20px] hover:bg-stone-300 "
        onClick={() => setIsModalOpen(true)}
      >
        <img
          className="w-[390px] h-[200px] mb-[10px] border-solid border-[1px]"
          src={`https://img.youtube.com/vi/${imageInformation}/0.jpg`}
        />
        {props.title}
      </div>

      <Modal
        isOpen={isModalOpen}
        style={{
          content: {
            width: "400px",
            height: "510px",
            margin: "auto",
            marginTop: "80px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          },
        }}
      >
        <Flex direction="column" alignItems="center">
          <Flex alignContent="center" mb="10px" mt="10px">
            <Text fontSize="2xl" mt="-1px" width="45px">
              제목:
            </Text>
            <Input
              htmlSize={30}
              defaultValue={value}
              onChange={handleChange}
              fontSize="xl"
              size="md"
            />
          </Flex>

          <Flex alignContent="center" mb="10px" mt="10px">
            <Text fontSize="2xl" mt="-1px" width="45px">
              주소:
            </Text>
            <Input
              htmlSize={30}
              defaultValue={videoUrl}
              onChange={handleVideoChange}
              fontSize="xl"
              size="md"
            />
          </Flex>

          <Image
            mt="10px"
            mb="10px"
            height="250px"
            src={`https://img.youtube.com/vi/${imageInformation}/0.jpg`}
            alt="미리보기"
          />
          <Text textAlign="center" as="b" fontSize="xl">
            유튜브 동영상 페이지에서{" "}
            <span style={{ color: "red" }}>공유 버튼</span>을 누른 후
          </Text>
          <Text textAlign="center" as="b" fontSize="xl">
            <span style={{ color: "red" }}>나오는 주소를 복사</span>하여 올리는
            것을 권장합니다.
          </Text>

          <Flex mt="15px" mb="10px">
            <ButtonGroup spacing="3">
              <Button
                variant="ghost"
                fontSize="3xl"
                px="10px"
                py="20px"
                onClick={clearState}
              >
                닫기
              </Button>
              <Button
                colorScheme="green"
                fontSize="3xl"
                px="10px"
                py="20px"
                onClick={confirmForm}
              >
                편집
              </Button>

              <Button
                colorScheme="red"
                fontSize="3xl"
                px="10px"
                py="20px"
                onClick={questionBeforeDelete}
              >
                삭제
              </Button>
            </ButtonGroup>
          </Flex>
        </Flex>
      </Modal>
    </>
  );
};
export default VideoCard;
